var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('img',{staticClass:"cover",attrs:{"src":require("@/assets/logo.png"),"alt":""}}),_c('span',{staticClass:"title hidden md:flex"},[_vm._v("MuleEx")])])
}]

export { render, staticRenderFns }